import React from 'react';
import classNames from 'classnames';

import Card from '@components/libraryV2/Card';
import ContentWell from '@components/libraryV2/ContentWell';
import Heading from '@components/libraryV2/Heading';
import ThemeText from '@components/libraryV2/ThemeText';
import TwoColumnContent from '@components/libraryV2/TwoColumnContent';

import ScoreImprovementSvg from '@svg/generic/score-improvement.svg';
import SparklesCauldronSvg from '@svg/generic/sparkles-cauldron.svg';

import * as styles from './styles.module.scss';

const Content = (props) => {
  const { attribution, children, icon, secondary } = props;

  return (
    <Card className={classNames(styles.card, secondary && styles.secondary)}>
      <div className={styles.icon}>{icon}</div>
      <div>
        <div className={styles.children}>{children}</div>
        <div className={styles.attribution}>{attribution}</div>
      </div>
    </Card>
  );
};

const ResearchBasedLearningScience = () => {
  return (
    <ContentWell size="dog" secondary tighten>
      <Heading className={styles.heading} size="h2" tagType="h2">
        Research-based <ThemeText>learning science</ThemeText>
      </Heading>
      <TwoColumnContent
        className={styles.columns}
        left={
          <Content
            icon={<ScoreImprovementSvg />}
            attribution="Karpicke & Roediger (2003)"
          >
            Use of repeated testing methodology while learning led to a 45% improvement in
            test scores over a non-testing study-only approach.
          </Content>
        }
        right={
          <Content
            icon={<SparklesCauldronSvg />}
            attribution="Modigliani and Hedges (1987)"
            secondary
          >
            Use of distributed practice methodology led to approximately 46% better recall
            than traditional study methods for the same material.
          </Content>
        }
      />
    </ContentWell>
  );
};

export default ResearchBasedLearningScience;
